import { Stack } from '@/shared/ui';
import { SvgIcon } from '@/shared/ui/SvgIcon';
import { CustomTypography } from '@/shared/ui/Typography';

import { CheckIcon } from '../selectableCardGroup/CheckIcon';

import { PaymentItemContainer } from './styles';

type TPaymentMethodContent = {
  iconName?: string;
  label: string;
  selected?: boolean;
};

export const PaymentMethodContent = ({
  iconName,
  label,
  selected,
}: TPaymentMethodContent) => {
  return (
    <PaymentItemContainer>
      <Stack direction="row" alignItems="center" gap={1}>
        {iconName ? <SvgIcon name={iconName} /> : null}
        <CustomTypography variant="h4">{label}</CustomTypography>
      </Stack>
      <CheckIcon selected={selected} />
    </PaymentItemContainer>
  );
};
